import { useContext, useMemo } from 'react';

import { DownloadOutlined } from '@ant-design/icons';

import { ActionButton } from '@hdi-seguros/web-components.action-button';
import { SectionSummary } from '../../../../../../../../../shared/components';
import { GenericDataFormContext, QUOTATION_BUTTON, QuotationInfoContext, StepOneFormContext } from '../../../../../shared';

import { StepFourFormContext } from '../../contexts/StepFourForm';

import {
  Column,
} from '../../../../../../../../production/InsurancePolicyDetail/utils/renderSections';
import {
  formattedPrice,
} from '../../../../../../../../../shared/utils';
import { getQuoteDocumentPDF, transformToPdfQuote } from '../../../../../utils';
import { BranchDocumentsURL, BudgetType } from '../../../../../utils/quotation-documents.enum';
import { QuotationContextData } from '../../../../../../../../../shared/interfaces/services/quote-pdf-service';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';

export const Summary = () => {
  const { quotationResponse, labelButton, commerceQuotationComponents, commercePaymentMethodsForm } = useContext(StepFourFormContext);
  const { stepOneForm, clientSelected } = useContext(StepOneFormContext);
  const { stepTwoForm, rubricSelected } = useContext(StepTwoFormContext);
  const { stepThreeForm, activeKey, tabs, plansByActivityList } = useContext(StepThreeFormContext);
  const { provinceList, allLocalitiesPerProvince, ivaConditionList, paymentMethods, allCoveragesPerPlan, paymentMethodsList} = useContext(GenericDataFormContext);
  const { quotationInfo } = useContext(QuotationInfoContext);

  const ctx: QuotationContextData = {
    stepOneForm,
    clientSelected,
    stepTwoForm, rubricSelected,
    stepThreeForm, activeKey, tabs, commercePaymentMethodsForm, plansByActivityList,
    quotationResponse, paymentMethodsList, commerceQuotationComponents,
    provinceList, allLocalitiesPerProvince, ivaConditionList, paymentMethods, allCoveragesPerPlan,
    quotationInfo,
    branchDocumentsURL: BranchDocumentsURL.INTEGRAL_COMERCIO
  };

  const summaryInfo: Array<Column[]> = useMemo(
    () => [
      [
        {
          label: 'Total suma asegurada:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR ? (
              labelButton
            ) : (
              <b>{`$ ${formattedPrice(quotationResponse?.sumaAsegurada)}`}</b>
            ),
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 10 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Prima técnica:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR
              ? labelButton
              : `$ ${formattedPrice(quotationResponse?.prima)}`,
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 7 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Comisión:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR
              ? labelButton
              : `$ ${formattedPrice(
                  quotationResponse?.condicionesComerciales.impComision
                )}`,
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 6 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Premio:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR
              ? labelButton
              : `$ ${formattedPrice(quotationResponse?.premio)}`,
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 10 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Acciones',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR ? (
              labelButton
            ) : (
              <>
                <ActionButton
                  className='btn-accent-outline-barbuss'
                  type='secondary'
                  label='Productor'
                  onClick={() => getQuoteDocumentPDF(transformToPdfQuote(ctx, BudgetType.PRODUCTOR), BranchDocumentsURL.INTEGRAL_COMERCIO)}
                  icon={<DownloadOutlined />}
                />
                <ActionButton
                  className='btn-accent-outline-barbuss'
                  type='secondary'
                  style={{ marginLeft: '1rem' }}
                  color='secondaryDefault'
                  label='Cliente'
                  onClick={() => getQuoteDocumentPDF(transformToPdfQuote(ctx, BudgetType.CLIENTE), BranchDocumentsURL.INTEGRAL_COMERCIO)}
                  icon={<DownloadOutlined />}
                />
              </>
            ),
          columnSize: {
            sm: { span: 24 },
            xs: { span: 24 },
            md: { span: 14 },
            lg: { span: 10 },
          },
        },
      ],
    ],
    [labelButton, quotationResponse]
  );

  return <SectionSummary summaryInfo={summaryInfo} />
};
